// ANGULAR
import { Injectable } from '@angular/core';
// STORE
import { select, Store } from '@ngrx/store';
import { MainState } from '@store/main.reducer';
import { logoutSuccess } from '@store/session/session.actions';
import { selectToken } from '@store/session/session.selectors';
// RXJS
import { first, Observable, of, switchMap } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard {
  constructor(
    private store: Store<MainState>,
  ) { }

  canActivate(): Observable<boolean> {
    return this.store.pipe(
      select(selectToken),
      first(),
      switchMap(
        token => {
          // console.log(token);
          if (token) {
            // Si el token está presente en la store, está autorizado
            return of(true);
          } else {
            // Si no hay token, forzamos el cierre de sesión
            this.store.dispatch(logoutSuccess());
            return of(false);
          }
        }
      )
    );
  }
}